"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SvgFishTagIcon = (0, react_1.forwardRef)((props, ref) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', ref: ref }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: 'currentColor', fillRule: 'nonzero', d: 'M22.257 0h-8.544c-.972 0-1.903.383-2.589 1.069L1.066 11.127a3.656 3.656 0 0 0 0 5.172l7.63 7.63a3.656 3.656 0 0 0 5.171 0L23.926 13.87a3.66 3.66 0 0 0 1.068-2.589L25 2.743A2.744 2.744 0 0 0 22.257 0m-1.829 6.4a1.829 1.829 0 1 1-3.658 0 1.829 1.829 0 0 1 3.658 0' }) })));
});
exports.default = (0, react_1.memo)(SvgFishTagIcon);
